module.exports = __webpack_public_path__ + "img/icon_map_5_on_001.53dade51.png";